import { render, staticRenderFns } from "./ScrollableGfx.vue?vue&type=template&id=7c810a38&scoped=true&"
import script from "./ScrollableGfx.vue?vue&type=script&lang=js&"
export * from "./ScrollableGfx.vue?vue&type=script&lang=js&"
import style0 from "./ScrollableGfx.vue?vue&type=style&index=0&id=7c810a38&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c810a38",
  null
  
)

export default component.exports